module.exports = __webpack_public_path__ + "img/lists.cc7fc46e.svg";